import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: "#062F63",
        secondary: "#BB9C0D",
        accent: "#2eb85c",
        error: "#FF5252",
        background: colors.grey.lighten4,
        aside: "#062F63",
        info: "#88AC2E",
      },
      dark: {
        background: colors.grey.darken3,
        primary: "#062F63",
        secondary: "#BB9C0D",
      },
    },
  },

  icons: {
    iconfont: "mdi",
  },
};

export default new Vuetify(opts);
